import {
  ComponentId,
  RugComponentStats,
  RugSectionStats,
} from 'pages/reporting/reports/rug/types'
import { hasSectionData } from 'pages/reporting/reports/rug/utils/calculateRUGStatsForSection'
import { isFullComponentSectionKey } from 'pages/reporting/reports/rug/utils/reportHeatmapStorage'
import { Section, Sectionable } from 'types'

export function isWholeComponentHeatmap({
  section,
  sectionKey,
  sectionable,
}: {
  section?: Section
  sectionKey?: string
  sectionable?: Sectionable
}): boolean {
  if (!section || isFullComponentSectionKey(sectionKey)) {
    return true
  }

  return (sectionable?.sections.length ?? 0) <= 1
}

/**
 * Floor (and similar) heatmaps are stored as the whole component, not named
 * courses. Those pages still have three-lows on `statsByComponent`.
 */
export function getRugDataImagePageStats({
  section,
  sectionKey,
  sectionable,
  componentId,
  statsBySection,
  statsByComponent,
}: {
  section?: Section
  sectionKey?: string
  sectionable?: Sectionable
  componentId: ComponentId
  statsBySection?: Map<ComponentId, Map<string, RugSectionStats>>
  statsByComponent?: Map<ComponentId, RugComponentStats>
}): {
  stats: RugComponentStats | undefined
  skipPage: boolean
} {
  const sectionStats = section
    ? statsBySection?.get(componentId)?.get(section.name)
    : undefined

  if (hasSectionData(sectionStats)) {
    return { stats: sectionStats, skipPage: false }
  }

  if (isWholeComponentHeatmap({ section, sectionKey, sectionable })) {
    return {
      stats: statsByComponent?.get(componentId),
      skipPage: false,
    }
  }

  if (sectionStats && !hasSectionData(sectionStats)) {
    return { stats: undefined, skipPage: true }
  }

  return { stats: sectionStats, skipPage: false }
}
